import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import { deserialize } from "utils/storeUtils";
import CategoryRepository from "repositories/CategoryRepository";

const initialState = {
  category: null,
};

const categorySlice = createSlice({
  name: "category",
  initialState,
  reducers: {
    loadCategorySuccess(state, { payload }) {
      state.category = deserialize(payload);
    },
    resetCategory(state) {
      state.category = null;
    },
  },
});

export const { actions } = categorySlice;
export default categorySlice.reducer;

export const useCategoryActions = () => {
  const dispatch = useDispatch();

  const loadCategory = (params) => {
    return CategoryRepository.index(params).then(({ data }) => {
      dispatch(actions.loadCategorySuccess(data));
    });
  };

  const resetCategory = () => dispatch(actions.resetCategory());

  return {
    loadCategory,
    resetCategory,
  };
};
